export var isEventInContainer = function isEventInContainer(event, containerSelector) {
  var target = event.target instanceof Element ? event.target : null;
  if (!target) {
    return false;
  }
  return !!target.closest(containerSelector);
};